import { render, staticRenderFns } from "./FiltrosPreventiva.vue?vue&type=template&id=b37c20f8&scoped=true&"
import script from "./FiltrosPreventiva.vue?vue&type=script&lang=js&"
export * from "./FiltrosPreventiva.vue?vue&type=script&lang=js&"
import style0 from "./NavBar/style.css?vue&type=style&index=0&id=b37c20f8&scoped=true&lang=css&"
import style1 from "./FiltrosPreventiva.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37c20f8",
  null
  
)

export default component.exports